import { render } from "./UserDetailCard.vue?vue&type=template&id=1a8dc7ac&scoped=true"
import script from "./UserDetailCard.vue?vue&type=script&lang=js"
export * from "./UserDetailCard.vue?vue&type=script&lang=js"

import "./UserDetailCard.vue?vue&type=style&index=0&id=1a8dc7ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8dc7ac"]])

export default __exports__